var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.43084 2.24334L8.27459 1.39959C8.6407 1.03347 9.2343 1.03347 9.60041 1.39959C9.96653 1.7657 9.96653 2.3593 9.60041 2.72541L4.29109 8.03473C4.02675 8.29907 3.70072 8.49338 3.34244 8.60011L2 9L2.39989 7.65756C2.50661 7.29929 2.70092 6.97325 2.96526 6.70891L7.43084 2.24334ZM7.43084 2.24334L8.75 3.5625M8 7V9.375C8 9.99632 7.49632 10.5 6.875 10.5H1.625C1.00368 10.5 0.5 9.99632 0.5 9.375V4.125C0.5 3.50368 1.00368 3 1.625 3H4",
    stroke: "#001F68",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.bf8f041e53598b814b8b4983ca3aa26f.svg";
export { ForwardRef as ReactComponent };